export enum EnumContractStatus {
  DRAFT = 1,
  PROCESSING = 2,
  REJECTED = 3,
  FINISHED = 4,
  CANCELLED = 5,
  CONNECTING = 6,
  RETRY = 7,
  FINISHED_DIGITAL = 8,
  WAIT_CONFIRM_ENTERPRISE_NO_MOIT = 9,
  TERMINATING = 10,
  TERMINATED = 11,
}

export enum EnumContractSendBCTStatus {
  NEW = 1,
  PROCESSING = 2,
  ERROR = 3,
  FINISHED = 4,
  CANCELLED = 5
}

export enum EnumContractEnterpriseStatus {
  NO_PROCESS = 1,     // Chưa xử lý
  PROCESSING = 2,     // Đang xử lý
  REJECTED = 3,       // Bị từ chối
  SIGNED = 4,         // Đã ký duyệt
  CANCELLED = 5,      // Đã hủy
  WAIT_SETUP_FLOW = 6, // Chờ thiết lập luồng
  STOP_PROCESS = 0 , // Trường hợp đặc biệt dừng xử lý
  DAEMON_PROCESSING = 7 // Xử lý nền
}

export enum EnumContractUserRole {
  SIGN = 1,       // Ký
  APPROVE = 2,    // Duyệt
  INITIAL = 3,    // Ký nháy
  CANCEL = 4,      // Huy luong
  CONFIRM = 6,      // Huy luong
}

export enum EnumContractUserStatus {
  STOP_PROCESS = 0, // Dừng xử lý
  NO_PROCESS = 1,     // Chưa xử lý
  PROCESSING = 2,     // Đang xử lý
  REJECTED = 3,       // Đã từ chối (Từ chối ký / Từ chối duyệt / Từ chối ký nháy)
  PROCESSED = 4,      // Đã xử lý (Đã ký / Đã duyệt / Đã Ký nháy)
  CANCELLED = 5,      // Đã hủy (do user lập thực hiện hủy luồng)
  DAEMON_PROCESSING = 6,      // Xử lý nền
  FINISHED_DIGITAL = 8,
  WAIT_CONFIRM_ENTERPRISE_NO_MOIT = 9,
}

export enum EnumLinkSignStatus {
  VALID = 1,          // Còn hiệu lực: Link ký chưa hết hạn
  EXPIRED = 2,        // Hết hạn: Link ký đã quá thời hạn sử dụng
  NOT_APPLICABLE = 3, // Không áp dụng: Đối với các trường hợp ký có đăng nhập
}

export enum EnumApproverStatus {
  STOP_PROCESS = 0, // Dừng xử lý
  NO_PROCESS = 1,     // Chưa xử lý
  PROCESSING = 2,     // Đang xử lý
  REJECTED = 3,       // Đã từ chố
  PROCESSED = 4,      // Đã xử lý
  DAEMON_PROCESSING = 6      // Xử lý nền
}

export enum EnumActionType {
  SIGN = 1,     // Chưa xử lý
  APPROVAL = 2,     // Đang xử lý
}

export enum EnumContractDetailType {
  ENTERPRISE = 1,
  USER = 2,
  DETAIL = 3
}

export enum EnumContractType {
  FORM = 0,
  FILE = 1
}


export enum EnumSignMethod {
  SIGN_SERVER = 0,
  SIGN_USB_TOKEN = 1,
  SIGN_SIM_CA = 2,
  SIGN_OTP = 3,
  SIGN_HSM = 4,
  SIGN_IMAGE = 5,
  SIGN_NO_CERT = 6,
  SIGN_EKYC = 7,
  SIGN_EKYC_ADVANCED = 8,
  SIGN_OTP_EKYC = 31,
  SIGN_OTP_EKYC_ADVANCED = 32,
  SIGN_NO_CERT_EKYC = 61,
  SIGN_NO_CERT_EKYC_ADVANCED = 62,
  CLOUD_CA = 10,
  SIGN_USB_TOKEN_LOT = 100,
  REGULAR = 99,
  EASY_CA = 11,
  VNEID = 12,
}

export enum EnumCustomerProcessingStatus {
  NO_PROCESS = 1,
  PROCESSING = 2,
  REJECTED = 3,
  SIGNED = 4,
  CANCELLED = 5,
  WAIT_SETUP_FLOW = 6,
}
export enum EnumColumnTable {
  CREATE_MY_CREATED_DOCUMENT = 1,
  CREATE_MY_RECEIVE_DOCUMENT = 2,
  CREATE_DOCUMENT_SIGN = 3,
  CREATE_APPROVAL_WAITING_DOCUMENT = 4,
  CREATE_INITIAL_WAITING_DOCUMENT = 5,
  CREATE_WAITING_CONFIRM_DOCUMENT = 6,
  CREATE_DOCUMENT = 7
}
export enum EnumAdjustedContents {
  THAY_DOI_MUC_LUONG_PHU_CAP = 'THAY_DOI_MUC_LUONG_PHU_CAP',
  GIA_HAN_HOP_DONG = 'GIA_HAN_HOP_DONG',
  CHAM_DUT_HOP_DONG = 'CHAM_DUT_HOP_DONG',
  THAY_DOI_VI_TRI_LAM_VIEC_DIA_DIEM = 'THAY_DOI_VI_TRI_LAM_VIEC_DIA_DIEM',
  THAY_DOI_THONG_TIN_BHXH = 'THAY_DOI_THONG_TIN_BHXH'
}
